export enum AcquisitionTypeEnum {
    NONE,
    PURCHASE
}
